import { CSSProperties } from 'react';

interface IProps {
    style?: CSSProperties;
}

const Loading = ({ style }: IProps) => {
    return (
        <div className="lds-roller" style={style}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    );
};

export default Loading;
